module.exports = __webpack_public_path__ + "10c9e23e6b5e2276f86db8234694f3b6.pdf";